import React from 'react';
import { Menu, Sticky } from 'semantic-ui-react';
import { arrayOf, string, func } from 'prop-types';
import { Link } from 'react-router-dom';

const Navigation = props => {
  const { terms, handleNavClick, currentNav } = props;
  return (
    <Sticky>
      <Menu pointing secondary style={{ backgroundColor: '#fff' }}>
        <Menu.Item
          name={terms[0]}
          active={currentNav === terms[0]}
          onClick={handleNavClick}
          as={Link}
          to="/series"
        />
        <Menu.Item
          name={terms[1]}
          active={currentNav === terms[1]}
          onClick={handleNavClick}
          as={Link}
          to="/programs"
        />
        <Menu.Item
          name={terms[2]}
          active={currentNav === terms[2]}
          onClick={handleNavClick}
          as={Link}
          to="/about"
        />
      </Menu>
    </Sticky>
  );
};

Navigation.propTypes = {
  terms: arrayOf(string).isRequired,
  handleNavClick: func.isRequired,
  currentNav: string.isRequired,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.jsx